import React, { useState } from "react";
import { Drawer } from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { hideAuthDrawer, isSignUpOpen } from "redux/reducers/drawerSlice";
import { isLoggedIn } from "redux/reducers/userSlice";
import SignUp from "./index";
import VerifyOtp from "./VerifyOtp";
import Security from "./Security";
import UserInfo from "./UserInfo";
import Preferences from "./Preferences";
import useMediaQuery from "lib/hooks/useMediaQuery";
interface Props {
  firstTab?: "signUp" | "verification" | "security" | "info" | "preference";
}

const SignUpDrawer = ({ firstTab }: Props) => {
  const dispatch = useAppDispatch();
  const _isSignUpOpen = useAppSelector(isSignUpOpen);
  const _isLoggedIn = useAppSelector(isLoggedIn);
  const [presentTab, setPresentTab] = useState<string>(
    firstTab ? firstTab : "signUp",
  );
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  const tabs = ["signUp", "verification", "security", "info", "preference"];
  const nextTab = (
    tab?: "signUp" | "verification" | "security" | "info" | "preference",
  ) => {
    if (tab) setPresentTab(tab);
    else {
      let index = tabs.indexOf(presentTab);

      if (index < tabs.length - 1) {
        setPresentTab(() => tabs[index + 1]);
      }
    }
  };
  const prevTab = () => {
    const index = tabs.indexOf(presentTab);
    if (index > 0) {
      setPresentTab(() => tabs[index - 1]);
    }
  };
  const TabToShow = () => {
    switch (presentTab) {
      case "signUp":
        return <SignUp nextTab={nextTab} />;
        break;
      case "verification":
        return <VerifyOtp nextTab={nextTab} prevTab={prevTab} />;
        break;
      case "security":
        return <Security nextTab={nextTab} />;
        break;
      case "info":
        return <UserInfo nextTab={nextTab} />;
        break;
      case "preference":
        return <Preferences nextTab={nextTab} />;
      default:
        return <SignUp nextTab={nextTab} />;
        break;
    }
  };

  return (
    <Drawer
      placement="right"
      onClose={() => dispatch(hideAuthDrawer())}
      open={_isSignUpOpen}
      closable={true}
      width={isSmallScreen ? "350px" : "450px"}
      destroyOnClose={true}
    >
      {React.cloneElement(TabToShow(), {
        nextTab,
        prevTab,
      })}
    </Drawer>
  );
};

export default SignUpDrawer;
